module.exports = __webpack_public_path__ + "static/img/honorBg-p.b848265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/honorBg-p.png
// module id = u52g
// module chunks = 1